// TelcoTrack - Forgot Password Component
// Form to request password reset email

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styles: []
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/maps']);
    }
  }

  async onSubmit(): Promise<void> {
    if (this.forgotForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        await firstValueFrom(this.authService.forgotPassword(this.forgotForm.value.email));
        this.successMessage = 'Pokud email existuje v systému, obdržíte odkaz pro reset hesla. Zkontrolujte svou schránku.';
      } catch (error) {
        this.errorMessage = error instanceof Error ? error.message : 'Nepodařilo se odeslat odkaz. Zkuste to prosím znovu.';
      } finally {
        this.isLoading = false;
      }
    } else {
      this.markFormGroupTouched();
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.forgotForm.controls).forEach(key => {
      this.forgotForm.get(key)?.markAsTouched();
    });
  }

  getFieldError(fieldName: string): string {
    const field = this.forgotForm.get(fieldName);
    if (field?.errors && field.touched) {
      if (field.errors['required']) return 'Toto pole je povinné';
      if (field.errors['email']) return 'Zadejte platnou emailovou adresu';
    }
    return '';
  }
}
